import {type Item} from '@/api/items';
import {PLATFORM_ID} from '@/lib/platform';
import {extractPinId} from '@/lib/pinterest';
import {extractYouTubeId} from '@/lib/youtube';

// The id an image-search match is recorded under for an item (the API's image-matches video_id): a
// YouTube video id, or a pin id on Falcon. Without the platform split, pin items would never find
// their match tier and the badges / match-strength filter would silently do nothing on Pinterest.
export function imageMatchIdFor(item: Pick<Item, 'url' | 'external_id'>): string | null {
  return PLATFORM_ID === 'pinterest'
    ? extractPinId(item.url, item.external_id)
    : extractYouTubeId(item.url, item.external_id);
}
